import DoubleArrowIcon from '@mui/icons-material/DoubleArrowRounded';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import { Avatar, Box, Typography } from '@mui/material';
import clsx from 'clsx';
import TimeAgo from 'javascript-time-ago';
import { useTranslation } from 'react-i18next';
import { ContentRequest, NotificationFieldsFragment } from '../../../../../../../../generated/core-api/graphql-react-query';
import RequestStateTag from '../RequestStateTag';

export default function ContentRequestUpdatedNotificationBox(props: { notification: NotificationFieldsFragment }) {
  const { notification } = props;
  const { t, i18n } = useTranslation('widgets');
  const timeAgo = new TimeAgo(i18n.language);

  return (
    <>
      <Avatar className="admin">
        <QuestionAnswerIcon />
      </Avatar>
      <Box className="message">
        <Typography variant="subtitle1">
          <strong>{notification.event.author?.displayName}</strong>
          {t('notifications.content-request.commented')}
        </Typography>
        <Typography variant="body1" component="div">
          <div className={clsx('project', { deleted: notification.event.contentRequest?.deletedAt })}>{notification.event.contentRequest?.title}</div>
        </Typography>
        <Typography variant="body2" component="div">
          <RequestStateTag request={{ state: notification.event.oldValue } as ContentRequest} />
          <DoubleArrowIcon />
          <RequestStateTag request={{ state: notification.event.newValue } as ContentRequest} />
        </Typography>

        <Typography variant="subtitle2">
          {timeAgo.format(new Date(notification.date))}
        </Typography>
        <Typography variant="subtitle2">
          {notification.event.project?.archived && `${t('notifications.deleted')} ${timeAgo.format(new Date(notification.date))}`}
        </Typography>
      </Box>
    </>
  );
}
